import { createApp } from 'vue'
import App from './App.vue'
import router from './router';
// Added by the CLI
import './registerServiceWorker';
import { IonicVue } from '@ionic/vue';
import OneSignalVuePlugin from '@onesignal/onesignal-vue3'
//import VueGtag from "vue-gtag";
//import { createGtm } from '@gtm-support/vue-gtm';
/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';

/* Theme variables */
import './theme/variables.css';

import store from './store';
import EventTracker from './plugins/eventTracker.js';
import { applyIonicPatches } from './ionic-fix.js';

// Apply Ionic patches to fix known bugs
applyIonicPatches();

// Create the app instance
const app = createApp(App);

// Apply plugins
app.use(store);
app.use(EventTracker);
//app.use(IonicVue);
app.use(IonicVue, {
  mode: 'ios', // 👈 force le style iOS, peu importe la plateforme
  animated: false // Disable transitions globally to prevent isViewVisible/classList errors
});
app.use(router);

// Add OneSignal plugin based on .env flags (Vue CLI)
// Set VUE_APP_ENABLE_ONESIGNAL=true and VUE_APP_ONESIGNAL_APP_ID in your env to enable
const enableOneSignal = process.env.VUE_APP_ENABLE_ONESIGNAL === 'true';
const oneSignalAppId = process.env.VUE_APP_ONESIGNAL_APP_ID;
if (enableOneSignal && oneSignalAppId) {
  app.use(OneSignalVuePlugin, { appId: oneSignalAppId });
}
  /*
  .use(
    createGtm({
      id: "GTM-5SR5NLVZ",
      vueRouter: router
    })
  )
 
.use(VueGtag, {
    config: { id: "GTM-5SR5NLVZ" }
  })
    */

router.isReady().then(() => {
  store.dispatch('loadTranslations');
  app.mount('#app');
});

async function checkAppVersion() {
  try {
    // Récupérer la version depuis le fichier JSON
    const response = await fetch("/version.json");
    const { version } = await response.json();

    // Vérifier la version stockée dans localStorage
    const storedVersion = localStorage.getItem("app_version");

    if (storedVersion) {
      // Comparer avec la version actuelle
      if (storedVersion !== version) {
        console.log("Nouvelle version détectée :", version);
        // Déclenche une action (exemple : recharger la page)
        handleUpdate(version);
      } else {
        console.log("L'application est à jour :", version);
      }
    } else {
      // Stocker la version actuelle si elle n'existe pas
      localStorage.setItem("app_version", version);
      console.log("Première exécution, version enregistrée :", version);
    }
  } catch (error) {
    console.error("Erreur lors de la vérification de la version :", error);
  }
}

function handleUpdate(newVersion) {
  // Exemple : afficher une notification
  const updateBanner = document.createElement("div");
  updateBanner.innerText = `Nouvelle version disponible (${newVersion}). Cliquez pour recharger.`;
  updateBanner.style.position = "fixed";
  updateBanner.style.bottom = "0";
  updateBanner.style.width = "100%";
  updateBanner.style.backgroundColor = "#ffcc00";
  updateBanner.style.color = "#000";
  updateBanner.style.textAlign = "center";
  updateBanner.style.padding = "10px";
  updateBanner.style.cursor = "pointer";

  updateBanner.onclick = () => {
    // Mettre à jour localStorage avant de recharger
    localStorage.setItem("app_version", newVersion);
    window.location.reload();
  };

  document.body.appendChild(updateBanner);
}

// Appeler la fonction au démarrage
//checkAppVersion();